module.exports = __webpack_public_path__ + "img/river-view-1.6b6f1f07.jpg";